export default "__VITE_ASSET__BpzQkHXK__"